import { render, staticRenderFns } from "./WebsitePages.vue?vue&type=template&id=00b046ae&"
import script from "./WebsitePages.vue?vue&type=script&lang=js&"
export * from "./WebsitePages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports